// download-type.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { JobType } from '../shared/models/progress.model';

@Injectable({
  providedIn: 'root'
})
export class DownloadTypeService {
  private readonly downloadTypeSubject = new BehaviorSubject<JobType>(0);

  public setDownloadType(type: JobType): void {
    this.downloadTypeSubject.next(type);
  }

  public getDownloadType(): JobType {
    return this.downloadTypeSubject.getValue();
  }
}
